import { render, staticRenderFns } from "./TransferenciaMedico.vue?vue&type=template&id=7ac06166&"
import script from "./TransferenciaMedico.vue?vue&type=script&lang=js&"
export * from "./TransferenciaMedico.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../front-end/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports